import API from "./API";

export default class SectionDiaries extends API
{
    static async all() {
        return super.get("api/admin/section-diaries/list");
    }

    static async search(filter) {
        return super.get("api/admin/section-diaries", { params: filter });
    }

    static async create(fields) {
        return super.post("api/admin/section-diaries", fields);
    }

    static async update(fields, id) {
        return super.put("api/admin/section-diaries/" + id, fields);
    }

    static async delete(id) {
        return super.delete("api/admin/section-diaries/" + id);
    }

    static async approve(id) {
        return super.put("api/admin/section-diaries/" + id + "/approve");
    }

    static async checkDay(user_id, date) {
        let params = {
            user_id: user_id,
            date: date
        };

        return super.get("api/admin/section-diaries/check-day", { params: params });
    }

    // Obter quais os users do meu departamento para exportar
    static async getUsersExport() {
        return super.get("api/admin/section-diaries/export-users");
    }

    static async getUsersList() {
        return super.get("api/admin/section-diaries/get-users-list/cc");
    }

    static async get(id) {
        return super.get("api/admin/section-diaries/" + id);
    }
}